{
    "contextmenu": {
        "global": {
            "cut": "剪切",
            "copy": "复制",
            "paste": "粘贴",
            "selectAll": "全选",
            "print": "打印"
        },
        "control": {
            "delete": "删除控件"
        },
        "hyperlink": {
            "delete": "删除链接",
            "cancel": "取消链接",
            "edit": "编辑链接"
        },
        "image": {
            "change": "更改图片",
            "saveAs": "另存为图片",
            "textWrap": "文字环绕",
            "textWrapType": {
                "embed": "嵌入型",
                "upDown": "上下型环绕",
                "surround": "四周型环绕",
                "floatTop": "浮于文字上方",
                "floatBottom": "衬于文字下方"
            }
        },
        "table": {
            "insertRowCol": "插入行列",
            "insertTopRow": "上方插入1行",
            "insertBottomRow": "下方插入1行",
            "insertLeftCol": "左侧插入1列",
            "insertRightCol": "右侧插入1列",
            "deleteRowCol": "删除行列",
            "deleteRow": "删除1行",
            "deleteCol": "删除1列",
            "deleteTable": "删除整个表格",
            "mergeCell": "合并单元格",
            "mergeCancelCell": "取消合并",
            "verticalAlign": "垂直对齐",
            "verticalAlignTop": "顶端对齐",
            "verticalAlignMiddle": "垂直居中",
            "verticalAlignBottom": "底端对齐",
            "border": "表格边框",
            "borderAll": "所有框线",
            "borderEmpty": "无框线",
            "borderDash": "虚框线",
            "borderExternal": "外侧框线",
            "borderInternal": "内侧框线",
            "borderTd": "单元格边框",
            "borderTdTop": "上边框",
            "borderTdRight": "右边框",
            "borderTdBottom": "下边框",
            "borderTdLeft": "左边框",
            "borderTdForward": "正斜线",
            "borderTdBack": "反斜线"
        }
    },
    "datePicker": {
        "now": "此刻",
        "confirm": "确定",
        "return": "返回日期",
        "timeSelect": "时间选择",
        "weeks": {
            "sun": "日",
            "mon": "一",
            "tue": "二",
            "wed": "三",
            "thu": "四",
            "fri": "五",
            "sat": "六"
        },
        "year": "年",
        "month": "月",
        "months": {
            "jan": "1月",
            "feb": "2月",
            "mar": "3月",
            "apr": "4月",
            "may": "5月",
            "jun": "6月",
            "jul": "7月",
            "aug": "8月",
            "sep": "9月",
            "oct": "10月",
            "nov": "11月",
            "dec": "12月"
        },
        "hour": "时",
        "minute": "分",
        "second": "秒"
    },
    "frame": {
        "header": "页眉",
        "footer": "页脚"
    },
    "pageBreak": {
        "displayName": "分页符"
    },
    "zone": {
        "headerTip": "双击编辑页眉",
        "footerTip": "双击编辑页脚"
    },
    "accessibility": {
        "selected": "选中：",
        "input": "输入："
    }
}
